import type { NavItem } from '@/vue-router'

export const heItems: NavItem[] = [
  {
    text: 'Workstreams',
    icon: '$stream',
    name: 'home',
  },
  {
    text: 'Complaints',
    icon: '$complaints',
    name: 'he/complaints',
  },
]

export const siItems: NavItem[] = [
  {
    text: 'Workstreams',
    icon: '$stream',
    name: 'si',
  },
]
